import React, { useEffect, useRef, useState } from "react";
import HeaderImage from "../../assets/landing/0003 - Still life Care is gold-Modifica copia.webp";
import logo from '../../assets/oroPrestige/logo-trasp.webp'
import LogoCare from "../../assets/logo/logo-400.webp";
import ParallaxImage1 from "../../assets/landing/parallax2.webp";
import ParallaxImage2 from "../../assets/landing/parallax1.webp";
import MouseFollowReusable from "../../components/MouseFollowReusable";
import imgSezione3 from "../../assets/landing/high-angle-view-of-handsome-businessman-relaxing.webp";
import imgSezione5 from "../../assets/landing/Grafico Oro  World Gold Council - Careisgold.jpg";
import imgSezione4 from "../../assets/landing/risk-protection-and-eliminating-the-risk-space.webp";
import imgSezione6 from "../../assets/landing/manoLingotto.webp";
import LandingTitle from "../../components/LandingTitle";
import { ScrollParallax } from "react-just-parallax";
import documentoImage from "../../assets/landing/OroCartaceo.webp";
import bitcoinImage from "../../assets/landing/BitCoin_1.webp";
import lingottiImage from "../../assets/landing/Lingotti.webp";
import iconDollar from "../../assets/landing/shutterstock_2450036909-copia.webp";
import iconGoldBar from "../../assets/landing/Lingotti.webp";
import LandingTextImage from "../../components/LandingTextImage";
import imgSezione8 from "../../assets/landing/0041-StillLifeCare.webp";
import phoneImg from "../../assets/landing/phone.webp";
import { CiAt } from "react-icons/ci";
import { FaPhoneVolume } from "react-icons/fa6";
import { SlScreenDesktop } from "react-icons/sl";
import { Link } from "react-router-dom";
import lingottiImg from "../../assets/landing/0084-CareIsGold.webp";
import handShake from "../../assets/landing/handshake.webp";
import ArrowRight from "../../assets/landing/arrow.webp";
import ContactForm from "../../components/contactForm/ContactForm";
import { Helmet } from 'react-helmet';

function StrategiaPatrimoniale() {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const contactRef = useRef(null);

  const handleContactClick = (e) => {
    e.preventDefault();
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const handleMouseMove = (event) => {
      const { clientX, clientY } = event;
      const moveX = (clientX / window.innerWidth - 0.5) * 20;
      const moveY = (clientY / window.innerHeight - 0.5) * 20;
      setPosition({ x: moveX, y: moveY });
    };

    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const contentParallaxSection = (
    <>
      <div className="absolute top-1/2 left-0 xl:left-10 -translate-y-1/2 xl:w-1/2 min-h-lvh xl:h-auto">
        <div data-aos="fade-right" data-aos-duration="1000">
          <div className="w-full h-2/5 xl:h-auto p-10 text-start flex items-center bg-gradient-to-r from-[#706762] xl:via-[#706762] to-transparent">
            <div className="xl:w-7/12 w-full">
              <h2 className="text-2xl md:text-4xl font-bold uppercase text-white">
                COSA FAI PER PROTEGGERE IL VALORE DEI TUOI CAPITALI?
              </h2>
            </div>
          </div>
          <div className="h-3/5 xl:h-auto text-start p-10 bg-gradient-to-r from-[#fff] xl:via-[#fff] to-transparent">
            <div className="xl:w-7/12 w-full">
              <p className="text-black font-bold text-xl md:text-3xl">
                SFIDE ATTUALI
              </p>
              <ul className="list-disc pl-5 mt-5 space-y-3 md:text-xl">
                <li className="">
                  <b>Inflazione e tassi d’interesse:</b> la tassa invisibile che
                  erode il tuo capitale.
                </li>
                <li className="">
                  <b>Liquidità parcheggiata in banca:</b> le somme sul conto
                  corrente diventano di proprietà della Banca, ex art. 1834
                  c.c..
                </li>
                <li className="">
                  <b>Prodotti finanziari:</b> i rendimenti sono sempre più
                  bassi.
                </li>
                <li className="">
                  <b>Crisi bancarie:</b> sempre più numerosi gli istituti che
                  affrontano profonde crisi.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
  const sezione3Title = (
    <>
      Chi costruisce valore reale <br /> conosce due verità:
    </>
  );
  const sezione4Title = (
    <>
      Per chi pensa al capitale come a un sistema da difendere,<br/> non a un
      numero da gestire
    </>
  );
  const sezione6Title = (
    <>
      Careisgold: l'oro fisico non è un investimento. <br /> è un'atto di
      intelligenza strategica.
    </>
  );

  const oroCartaceo = (
    <>
      <p className="text-xl">È un contratto, un titolo che spesso è</p>
      <p className="text-xl">quotato in borsa.</p>
      <p className="text-xl">È soggetto al rischio dell’emittente.</p>
    </>
  );
  const oroDigitale = (
    <>
      <p className="text-xl">È una rappresentazione digitale.</p>
      <p className="text-xl">Non vi è un quadro normativo chiaro.</p>
      <p className="text-xl">Il rischio è nei dettagli.</p>
    </>
  );

  const oroFisico = (
    <>
      <p className="text-xl">È un bene tangibile, lo puoi toccare.</p>
      <p className="text-xl">
        È considerato per Basilea3 asset a rischio zero, <br /> equiparato a
        contante. È Esente IVA.
      </p>
      <p className="text-xl">
        Se custodito in Italia non va dichiarato nel quadro RW.
      </p>
      <p className="text-xl mt-5">Scegli solo la custodia giusta.</p>
    </>
  );

  var ogImage = 'https://www.careisgold.it/static/media/azienda_sede.ef12f4d81d9d70e63532.webp';

  return (
    <>
      <Helmet>
        <title>Lingotti oro da investimento | Careisgold</title>
        <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
        <meta name="description" content="Vuoi mettere al sicuro i tuoi capitali? Careisgold ti accompagna nella diversificazione del tuo portafoglio, scopri come!" />
        <meta property="og:title" content="Careisgold SpA" />
        <meta property="og:description" content="Vuoi mettere al sicuro i tuoi capitali? Careisgold ti accompagna nella diversificazione del tuo portafoglio, scopri come!" />
        <meta property="og:image" content={ogImage} />
        <meta property="og:url" content="https://www.careisgold.it/strategia-patrimoniale/" />
        <meta property="og:type" content="page" />
        <meta name="keywords" content="investimento in oro, come investire in oro fisico, servizi di investimento in oro Careisgold, testimonianze reali investimento oro, benefici dell'oro come bene rifugio" />
        <link rel="canonical" href="https://www.careisgold.it/strategia-patrimoniale/" />
        <script type="application/ld+json">
        {`
          {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Tutto su Investimenti in Oro | Careisgold",
            "url": "https://www.careisgold.it/strategia-patrimoniale/",
            "description": "Vuoi mettere al sicuro i tuoi capitali? Careisgold ti accompagna nella diversificazione del tuo portafoglio, scopri come!",
            "inLanguage": "it",
            "primaryImageOfPage": {
              "@type": "ImageObject",
              "url": "https://www.careisgold.it${HeaderImage}"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Careisgold SpA",
              "logo": {
                "@type": "ImageObject",
                "url": "https://www.careisgold.it${logo}"
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Via Monte Baldo 14/D",
                "addressLocality": "Villafranca di Verona",
                "addressRegion": "Veneto",
                "postalCode": "37069",
                "addressCountry": "IT"
              },
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+39 045 8213155",
                "contactType": "Customer Service"
              },
              "sameAs": [
                "https://www.facebook.com/careisgoldspa",
                "https://www.instagram.com/careisgoldspa",
                "https://www.linkedin.com/company/careisgold-spa"
              ]
            }
          }
        `}
        </script>
      </Helmet>

      <div className="pb-20 bg-white">
        <div className="relative z-20 h-lvh overflow-hidden">
          <ScrollParallax
            enableOnTouchDevice={true}
            isAbsolutelyPositioned={true}
            lerpEase="0.05"
          >
            <img
              src={HeaderImage}
              alt="header"
              className="absolute top-0 left-0 w-full h-full object-cover z-0"
            />
          </ScrollParallax>
          <div
            data-aos="fade-up"
            data-aos-duration="1500"
            className="absolute bottom-0 w-full bg-gradient-to-t from-white via-white/85 via-[70%] to-transparent"
          >
            <div className="space-y-5 mt-[15rem] mx-auto p-5 w-full md:w-2/3">
              <h1 className="text-[#706763] text-2xl md:text-5xl font-bold uppercase">
                METTI AL SICURO I TUOI CAPITALI CON L'ORO PURO FISICO DA
                INVESTIMENTO
              </h1>
              <p className="md:text-lg">
                In un contesto economico dominato da inflazione, instabilità bancaria e volatilità dei mercati,{' '}<strong>tutelare il proprio capitale</strong> non è più
                un’opzione. L’<strong>Oro Fisico da investimento</strong>{' '} rappresenta da sempre un bene rifugio per chi vuole preservare potere d’acquisto e stabilità,
                con una <strong>Visione di lungo periodo</strong>.
              </p>
            </div>
            <div className="w-[10rem] md:w-[18rem] mx-auto mt-5 mb-5">
              <img
                src={LogoCare}
                alt="logo careisgold"
                className="object-contain"
              />
            </div>
            <div className="w-full mx-auto mt-5 mb-5">
              <span
                className={`contact-strategia-patrimoniale page-link border-black text-black progress-button-dark px-8 py-2 uppercase border text-center transition duration-300 ease-in-out mt-5 cursor-pointer`}
                onClick={(e) => handleContactClick(e)}
              >
                Scopri di più
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* parallax section */}
      <MouseFollowReusable
        headerImage={ParallaxImage1}
        overlayImage={ParallaxImage2}
        content={contentParallaxSection}
        altHeaderImage="città con diversi grattaciali, spessol legata al mondo della finanza"
        altOverlayImage="uomo d'affari che cerca di rimanere in equilibrio su una corda a simboleggiare le sfide da affrontare nel proteggere i propri capitali"
      />

      {/*SEZIONE 3 VALORE REALE */}
      <div className="bg-white">
        <LandingTitle
          title={sezione3Title}
          titleClass={"text-white bg-[#706763] text-end"}
          justifyContent="start"
        />
        <div className="lg:w-2/3 w-full pt-10 px-10 pr-10 text-end">
          <ol className="list-decimal ml-10 text-left lg:w-2/3 md:text-xl md:py-10 space-y-3">
            <li data-aos="fade-in" data-aos-duration="1000">
              Il denaro liquido oggi non è ricchezza,{" "}
              <span className="font-bold">è esposizione.</span>{" "}
            </li>
            <li data-aos="fade-in" data-aos-duration="1000">
              <span className="font-bold">
                Trascurare la protezione del capitale
              </span>{" "}
              significa delegare ad altri il <br /> destino del proprio capitale
              personale e aziendale.
            </li>
          </ol>
        </div>

        <div className="lg:w-2/3 w-full px-10 pr-10 text-end">
          <div className="ml-5 text-left lg:w-2/3 md:text-xl py-10 space-y-3">
            <p
              className="uppercase font-bold text-[#706763] text-xl md:text-3xl"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              OGGI, PROTEGGERE IL PROPRIO CAPITALE È UNA SCELTA CONSAPEVOLE E
              NON È PIÙ UN’ALTERNATIVA.
            </p>
          </div>
        </div>

          {/* <div className="pb-10 mt-12 flex justify-start">
          <div className="lg:w-1/3 text-xl py-10 pl-5 text-left lg:ml-20">
            <p
              className="uppercase font-bold text-[#706763] text-xl md:text-3xl"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              OGGI, PROTEGGERE IL PROPRIO PATRIMONIO È UNA SCELTA CONSAPEVOLE E
              NON È PIÙ UN’ALTERNATIVA.
            </p>
          </div>
        </div> */}

      </div>

      {/*SEZIONE 4  Ti spieghiamo perchè ... */}
      <div
        style={{
          backgroundImage: `url(${imgSezione4})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="pb-10"
      >
        <LandingTitle
          title={sezione4Title}
          titleClass={"bg-[#706763] text-white md:bg-white md:text-[#706763]"}
          justifyContent="end"
        />
        <div className="pl-5 md:pl-0 pb-10 mt-12 flex justify-center lg:justify-end">
          <h3 className="uppercase font-bold text-white text-xl md:text-2xl text-left lg:w-2/3 pl-5 md:pl-0">
            TI SPIEGHIAMO PERCHÉ ABBIAMO SCELTO <br />
            L’ORO PURO FISICO DA INVESTIMENTO PER I NOSTRI CLIENTI
          </h3>
        </div>
        <div>
          <LandingTextImage
            title={"Oro cartaceo"}
            text={oroCartaceo}
            image={documentoImage}
            alt="documento"
          />
          <LandingTextImage
            title={"Oro digitale"}
            text={oroDigitale}
            image={bitcoinImage}
            textRight
            alt="cryptovaluta"
          />
          <LandingTextImage
            title={"Oro fisico"}
            text={oroFisico}
            image={lingottiImage}
            alt="lingotti d'oro puro fisico da investimento"
          />
        </div>
      </div>

      {/* sezione 5 rivalutazione*/}
      <div className="bg-white flex flex-col 2xl:flex-row justify-center overflow-x-hidden">
        <div className="w-full 2xl:w-7/12 px-5 md:px-20 relative mt-20">
          {/* HEADER SECTION */}
          <h2 className="text-black text-2xl md:text-5xl font-semibold text-start">
            DAL 2000 AD OGGI, L’ORO DA INVESTIMENTO HA <b>AUMENTATO IL</b> SUO{" "}
            <b>VALORE</b> DI <b>OLTRE 10 VOLTE</b>.
          </h2>

          {/* DESCRIPTION */}
          <p className="text-black md:text-xl my-10 text-start">
            Se nell’<b>ANNO 2000</b> avessi avuto a disposizione un capitale di{" "}
            <b>€ 8.653,37</b>, avresti potuto lasciarlo depositato sul conto
            corrente o proteggerlo acquistando 1 kg di Oro Puro Fisico.
          </p>

          {/* VERTICAL LINE */}
          <div className="absolute left-1/2 -translate-x-1/2  w-[0.5px] h-[25rem] md:h-[16rem] bg-black mx-auto mt-5 hidden md:block"></div>

          {/* LINE CONNECTIONS */}
          <div className="relative flex justify-center items-center md:mt-36">
            {/* HORIZONTAL LINES */}
            <div className="absolute top-1/2 w-10/12 h-1/2 bg-white border-t-[1px] border-black hidden md:block"></div>

            {/* COMPARISON BOXES */}
            <div className="flex flex-col md:flex-row justify-between items-center mt-10 w-full">
              {/* CASH VALUE */}
              <div className="bg-[#706763] w-full md:w-5/12 p-6 text-right relative">
                <img
                  src={iconDollar}
                  alt="Money"
                  className="mx-auto absolute -left-32 bottom-[6rem] md:bottom-[9rem] w-96"
                />
                <h5 className="text-white text-lg lg:text-2xl mt-4">
                  Il capitale in <b>denaro OGGI</b> sarebbe circa
                </h5>
                <p className="text-xl lg:text-4xl font-bold text-white mt-2">
                  € 14.035,77
                </p>
                <p className="text-sm text-white mt-2">
                  Fonte: ISTAT Gen 2000 &gt; Gen 2026
                </p>
              </div>

              {/* GOLD VALUE */}
              <div className="bg-[#706763] w-full md:w-5/12 p-6 text-left relative mt-5 md:mt-0">
                <img
                  src={iconGoldBar}
                  alt="Gold bars"
                  className="mx-auto absolute -right-20 md:-right-10 -bottom-[0rem] md:bottom-[8rem] w-40"
                />
                <h5 className="text-white text-lg lg:text-2xl mt-4">
                  Il capitale in <b>Oro OGGI</b> sarebbe circa
                </h5>
                <p className="text-xl lg:text-4xl font-bold text-white mt-2">
                  € 128.471
                </p>
                <p className="text-sm text-white mt-2">
                  Fonte: Quotazione LBMA del 15/05/2026 PM
                </p>
              </div>
            </div>
          </div>

          {/* DISCLAIMER */}
          <p className="text-sm text-black text-start my-5">
            L’andamento del valore dell’Oro nel passato non è indicativo delle
            performance future.
          </p>
        </div>
        <div className="w-full 2xl:w-5/12 2xl:text-start text-center mt-auto p-5">
          <h4 className="text-black text-xl md:text-2xl font-bold">
            Quotazione in € al grammo
          </h4>
          <p className="text-black text-xl md:text-2xl">
            Periodo 2000 - Aprile 2026
          </p>
          <h3 className="text-black text-2xl md:text-5xl font-bold mt-10 text-start pl-0 md:pl-5 2xl:pl-0">
            RIVALUTAZIONE
          </h3>
          <img src={imgSezione5} alt="" className="object-contain" />
        </div>
      </div>
      <div className="w-full mx-auto pt-5 md:pt-10 md:pb-20 text-center bg-white">
            <span
              className={`contact-strategia-patrimoniale page-link border-black text-black progress-button-dark px-12 py-2 uppercase border text-center transition duration-300 ease-in-out mt-5 cursor-pointer`}
              onClick={(e) => handleContactClick(e)}
            >
              Scopri di più
            </span>
      </div>

      {/* SEZIONE 6 - RISERVA AUREA */}
      <div
        style={{
          backgroundImage:
            window.innerWidth >= 768 ? `url(${imgSezione6})` : "none",
        }}
        className={`md:py-24 bg-cover bg-center bg-white`}
      >
        <LandingTitle
          title={sezione6Title}
          titleClass={
            "text-white bg-gradient-to-r from-[#706762] via-[#706762] to-[#706762] md:to-transparent"
          }
        />
        <div className="pt-10 pb-0 md:py-10 pl-5 md:p-10 lg:w-2/3 w-full flex flex-col justify-center lg:justify-start bg-gradient-to-r from-[#fff] via-[#fff] to-[#fff]  md:to-transparent">
          <h3 className="uppercase text-xl md:text-2xl text-left lg:w-2/3  md:pl-0 mb-5 md:mb-16 pe-5">
            Inizia oggi a costruire{" "}
            <span className="font-bold">
              la tua riserva aurea
            </span>{" "}
            con un piano su misura.
          </h3>
          <ul
            className="text-left md:text-xl w-2/3  space-y-3"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <li>
              <p>
                <span className="font-bold">
                  Investi secondo le tue logiche.{" "}
                </span>
                Decidi tu l'importo, la durata e la periodicità: massima
                flessibilità, totale controllo.
              </p>
            </li>
            <li>
              <p>
                <span className="font-bold">
                  Oro custodito con standard elevati.{" "}
                </span>
                Deposito garantito nei caveau blindati del Gruppo Battistolli,
                con copertura assicurativa integrale.
              </p>
            </li>
            <li>
              <p>
                <span className="font-bold">
                  Tecnologia al servizio del capitale.{" "}
                </span>
                Monitora in tempo reale la tua posizione in oro attraverso
                un’App intuitiva e dedicata.
              </p>
            </li>
            <li>
              <p>
                <span className="font-bold"> Liquidabilità. </span> Puoi
                rivendere in qualsiasi momento a Careisgold e ricevere in poco
                tempo il controvalore in Euro.
              </p>
            </li>
          </ul>
        </div>
      </div>
      {/* section 7  - servizio clienti*/}
      <div className="flex flex-col xl:flex-row justify-center  bg-white">
        <div className="w-full xl:w-2/3 md:h-lvh flex justify-start items-center">
          <div className="">
            <LandingTitle
              title="SERVIZIO CLIENTI ECCELLENTE"
              titleClass={"text-white bg-[#706763]"}
              justifyContent="start"
            />
            <div className="text-start pl-10 py-5">
              <h3 className="text-xl md:text-2xl">
                IL NOSTRO OBIETTIVO È LA <b>TUA SOLIDITÀ</b>
              </h3>
            </div>
            <div className="flex flex-col md:flex-row justify-start items-center gap-5 md:gap-10 w-full px-5 md:px-10 pb-10 md:py-20">
              <div className="relative">
                <img
                  src={handShake}
                  alt="immagine consulente"
                  className="object-contain rounded-full w-[10rem] md:w-[15rem]"
                />
                <img
                  src={ArrowRight}
                  alt="immagine consulente"
                  className="absolute left-20 md:left-36 bottom-28 object-contain rounded-full w-[15rem] hidden md:block"
                />
              </div>
              <div className="text-start">
                <h3 className="text-xl md:text-3xl font-bold md:mt-5">
                  Disponibilità e competenza:
                </h3>
                <p className="md:text-xl mt-5">
                  I nostri esperti ascoltano le tue esigenze e offrono soluzioni
                  personalizzate.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full xl:w-1/3 hidden xl:block">
          <img
            src={imgSezione3}
            alt="immagine consulente"
            className="object-cover h-full w-full"
          />
        </div>
      </div>

      {/* SEZIONE 8 - TRASPARENZA */}
      <div
        style={{
          backgroundImage: `url(${imgSezione8})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
        className="pt-5 pb-24 bg-black overflow-x-hidden"
      >
        <LandingTitle
          title={"massima trasparenza"}
          titleClass={
            "text-white  bg-gradient-to-r from-[#706762] xl:via-[#706762] to-transparent"
          }
          justifyContent={"end"}
        />
        <div className="flex flex-col md:flex-row justify-center mt-20">
          <div className="md:w-4/5 lg:w-1/3">
            <img src={phoneImg} alt="" className="-rotate-[15deg]" />
          </div>
          <div className="w-full lg:w-1/2 xl:w-1/3 text-white text-left text-xl lg:text-2xl space-y-10 flex flex-col justify-center p-10 bg-gradient-to-r from-[#000] via-[60%] via-[#000] to-transparent md:bg-none">
            <div className="md:w-2/3 space-y-4">
              <p className="font-bold">Portale riservato e App dedicata:</p>
              <p>
                Resta aggiornato sulla progressione del tuo piano grazie a
                un’area clienti esclusiva.
              </p>
            </div>
            <div className="md:w-2/3 space-y-4">
              <p className="font-bold uppercase">Vantaggio: </p>
              <p className="uppercase">
                Con noi, sai sempre dove si trova il tuo oro e il{" "}
                <span className="font-bold">suo valore</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* SEZIONE 9 - CONTATTI */}
      <div className="bg-[#D5D6D1] overflow-x-hidden">
        <div className="p-10">
          <h2 className="text-black text-2xl md:text-4xl font-bold uppercase mb-10">
            Il momento di agire è adesso
          </h2>
          <h3 className="uppercase text-xl md:text-3xl">
            CONTATTACI E SCOPRI COME <br /> PROTEGGERE I TUOI CAPITALI OGGI
          </h3>
        </div>
        <div
          ref={contactRef}
          className="max-w-3xl mx-auto rounded-lg p-10 mb-20"
        >
          <ContactForm
            Theme='light'
            LandingName="landing strategia patrimoniale"
            Name={true}
            NameText="Nome e Cognome:"
            NameRequired={true}
            Tel={true}
            TelText="Telefono:"
            TelRequired={true}
            Email={true}
            EmailText="Email:"
            EmailRequired={true}
            provincia={true}
            provinciaText="Provincia:"
            provinciaRequired={true}
            Dropdown={true}
            DropdownRequired={true}
            DropdownItem={[
              "Acquisto di un piano rateale",
              "Acquisto unico",
              "Lavorare con noi",
            ]}
            DropdownText="Interessato a:"
            SendText="Invia"
            Message={true}
            MessageText="Messaggio:"
            MessageTextRequired={false}
            ConsensoDati={true}
            ConsensoDatiRequired={true}
            ConsensoDatiText="Informativa Privacy"
            ConsensoDatiID={1}
            Newsletter={false}
            NewsletterRequired={false}
            NewsletterText="consenso dati newsletter"
            NewsletterID={21}
            successText="Messaggio inviato con successo!"
            successLink="/"
            errorText="Si è verificato un errore, Riprova!"
          />
        </div>
        <div className="flex flex-col md:flex-row md:justify-around lg:w-1/2 mx-auto md:mt-20">
          <a
            className="font-bold"
            target="_blank"
            rel="noreferrer"
            href="mailto:info@careisgold.it"
          >
            <div className="flex flex-col items-center mb-10">
              <CiAt className="text-gold text-3xl md:text-6xl mb-5" />
              info@careisgold.it
            </div>
          </a>
          <a className="font-bold" target="_blank" rel="noreferrer" href="tel:+390452457421">
            <div className="flex flex-col items-center mb-10">
              <FaPhoneVolume className="text-gold text-3xl md:text-6xl mb-5" />
              +39 045 2457421
            </div>
          </a>
          <Link className="" to="/">
            <div className="flex flex-col items-center mb-10 font-bold">
              <SlScreenDesktop className="text-gold text-3xl md:text-6xl mb-5" />
              www.careisgold.it
            </div>
          </Link>
        </div>
        <div className="w-[10rem] md:w-[18rem] mx-auto mt-10 pb-10">
          <img
            src={LogoCare}
            alt="logo careisgold"
            className="object-contain"
          />
        </div>
        <div className="font-light italic">
          <h3 className="uppercase text-xl md:text-3xl ">Oro fisico</h3>
          <p className="text-xl md:text-3xl">
            La Tua Protezione Personale <br /> e Aziendale
          </p>
        </div>
        <div>
          <img src={lingottiImg} alt="lingotti" className="object-contain" />
        </div>
      </div>
    </>
  );
}

export default StrategiaPatrimoniale;
